import { AvailableSlotResponse } from "../clients/AvailableSlotsResponse";
import { Slot } from "../EarliestAvailableSlots";
import { format } from "./currencyFormatter";

export const mapEarliestAvailableSlots = (
  availableSlotResponse: AvailableSlotResponse,
): Slot[] | undefined => {
  const { earliestSlot, earliestFreeSlot } = availableSlotResponse;

  if (!earliestFreeSlot && !earliestSlot) return;

  const slotAndDates: SlotAndDate[] = [];

  let freeDate: Date | undefined;
  let paidDate: Date | undefined;

  let freeSlot: Slot | undefined;
  if (earliestFreeSlot?.slot) {
    freeDate = new Date(earliestFreeSlot.slot.startDateTime);
    freeSlot = {
      description: formatSlotDate(earliestFreeSlot.slot),
      cost: "Free",
    };
    const free = {
      date: freeDate,
      slot: freeSlot,
    };
    slotAndDates.push(free);
  }

  if (earliestSlot?.slot) {
    paidDate = new Date(earliestSlot.slot.startDateTime);
    const paid = {
      date: paidDate,
      slot: {
        description: formatSlotDate(earliestSlot.slot),
        cost: format(earliestSlot?.cost.amount),
      },
    };
    slotAndDates.push(paid);
  }

  if (freeSlot && datesAreTheSame(paidDate, freeDate)) {
    return [freeSlot];
  }

  return slotAndDates
    .sort((a, b) => a.date.getTime() - b.date.getTime())
    .map((slotAndDate) => slotAndDate.slot);
};

type SlotAndDate = {
  slot: Slot;
  date: Date;
};

const formatSlotDate = (slot: {
  startDateTime: string;
  endDateTime: string;
}) => {
  const startDate = new Date(slot.startDateTime);
  const formattedDate = startDate.toLocaleDateString(
    "en-GB",
    dateFormatOptions,
  );
  return `${formatDayMonth(formattedDate)}`;
};

const formatDayMonth = (formattedDate: string) => {
  const dateBits = formattedDate.split(",");
  let dayMonthPortion = dateBits[0];
  if (dateBits[1]) {
    dayMonthPortion = dayMonthPortion + dateBits[1];
  }

  return dayMonthPortion;
};

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  month: "long",
  day: "numeric",
};

const datesAreTheSame = (date1?: Date, date2?: Date): boolean => {
  if (!date1 || !date2) return false;

  const strippedDate1 = new Date(date1);
  strippedDate1.setHours(0, 0, 0, 0);

  const strippedDate2 = new Date(date2);
  strippedDate2.setHours(0, 0, 0, 0);

  return strippedDate1.getTime() === strippedDate2.getTime();
};
